import { Button } from "antd";
import Header from "./components/Header";
import logo from "./logo.png";

function App() {
  return (
    <div
      className="App"
      style={{
        backgroundColor: "#101113",
        minHeight: "100vh",
      }}
    >
      <svg style={{ position: "absolute", top: -99999 }}>
        <defs>
          <clipPath
            id="mask1"
            style={{
              transform: "scale(50%) translateX(250%) translateY(300%)",
            }}
          >
            <path
              d="M1131.03 165.89C1015.22 35.9455 952.987 18.2222 877.028 15.8899C803.934 -9.09941 649.449 110.414 519.028 165.89C380.027 225.015 223.817 156.426 112.028 240.89C13.1428 315.603 -5.50368 416.65 27.46 504.612C60.4237 592.574 181.65 598.628 232.528 654.048C310.528 739.012 464.11 733.347 549.863 739.012C646.127 710.69 825.028 689.89 918.197 739.012C1000.56 782.436 1202.69 710.69 1305.16 654.048C1337.89 578.247 1401.57 350.271 1323.03 305.89C1224.85 250.414 1206.3 250.354 1131.03 165.89Z"
              fill="black"
              stroke="black"
              stroke-width="25"
            />
          </clipPath>
          <clipPath
            id="mask12"
            style={{
              transform: "scale(70%) translateX(110%) translateY(180%)",
            }}
          >
            <path
              d="M1131.03 165.89C1015.22 35.9455 952.987 18.2222 877.028 15.8899C803.934 -9.09941 649.449 110.414 519.028 165.89C380.027 225.015 223.817 156.426 112.028 240.89C13.1428 315.603 -5.50368 416.65 27.46 504.612C60.4237 592.574 181.65 598.628 232.528 654.048C310.528 739.012 464.11 733.347 549.863 739.012C646.127 710.69 825.028 689.89 918.197 739.012C1000.56 782.436 1202.69 710.69 1305.16 654.048C1337.89 578.247 1401.57 350.271 1323.03 305.89C1224.85 250.414 1206.3 250.354 1131.03 165.89Z"
              fill="black"
              stroke="black"
              stroke-width="25"
            />
          </clipPath>
        </defs>
      </svg>
      <svg style={{ position: "absolute", zIndex: -10, top: -99999 }}>
        <defs>
          <clipPath id="mask2">
            <path
              d="M675 104.5C557.8 26.5 258.5 72 187 104.5C92.4998 147.455 71.4998 257.1 53.4998 387.5C30.9998 550.5 121.5 780.476 252 902C359.5 1002.11 1007.54 1078 1108 1078C1196 1078 1378 993 1378 882.5C1378 817.5 1392.14 724.758 1342.5 667.5C1235 543.5 1056 469.5 1004 433.5C965.722 407 821.5 202 675 104.5Z"
              fill="black"
              stroke="black"
              stroke-width="25"
            />
          </clipPath>
        </defs>
      </svg>
      <svg style={{ position: "absolute", zIndex: -10, top: -99999 }}>
        <defs>
          <clipPath
            id="mask3"
            style={{
              transform: "scale(50%) translateX(170%) translateY(200%)",
            }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M328 407.5C447.333 290.5 630.631 99.9401 686 205.5C755.5 338 875 175.5 988 175.5C1049.74 175.5 1100.67 232.833 1124 281.5C1177 374.5 1339.5 43 1412.5 175.5C1485.5 318 1479 314.5 1518.5 281.5C1558 248.5 1612.98 184.77 1665 205.5C1731.5 232 1807.5 258.5 1807.5 374.5C1752.17 501.5 1586.8 796.6 1502 895C1396 1018 1213.5 1170.5 1124 1107.5C1034.5 1044.5 1080.5 1070.5 1054 1021C1027.5 971.5 908 994.5 875 1051C842 1107.5 745.5 1130 739 1090.5C732.5 1051 636.5 885 600 948C550.5 1017.5 321 1070.5 354.5 948C388 825.5 322 881.5 196 852C82.041 825.319 199 497 328 407.5Z"
              fill="black"
              stroke="black"
            />
          </clipPath>
        </defs>
      </svg>

      <Header logo={logo} />
      <div
        className="container minibit"
        style={{
          height: "815px",
          marginTop: "-7rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h1>MiniBit</h1>
        <h2 style={{ marginBottom: "5rem" }}>Compressor</h2>
        <Button type="primary" size="large" href="/minibit">
          Şimdi Başla!
        </Button>
      </div>

      <div
        className="container giris"
        id="giris"
        style={{
          height: "815px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "-10%",
        }}
      >
        <h1>Giriş</h1>
      </div>
      <div
        className="container girisdevami"
        id="giris"
        style={{
          height: "1100px",
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "center",
          marginTop: "-15%",
        }}
      >
        <h3
          style={{
            width: "42%",
            marginLeft: "10%",
            marginTop: "3%",
            textAlign: "center",
          }}
        >
          Derin uzay iletişimi, Dünya'dan milyonlarca kilometre uzaktaki uzay
          araçları ile NASA'nın Derin Uzay Ağı gibi istasyonlar arasında, radyo
          dalgaları kullanılarak gerçekleştirilen iki yönlü veri aktarımıdır. Bu
          sistem, araçlara komut gönderir, telemetri verileri alır ve bilimsel
          görüntüler sağlar.{" "}
        </h3>
        <h3
          style={{
            width: "60%",
            marginLeft: "auto",
            marginRight: "15%",
            marginTop: "7%",
            textAlign: "center",
          }}
        >
          Fakat derin uzay iletişimi, çok uzun mesafeler nedeniyle sinyal
          gücünün aşırı düşmesi, sınırlı enerji kaynağı ve uzay gürültüsü gibi
          faktörler yüzünden verileri sıkıştırır. Bu işlem, Derin Uzay Ağı gibi
          yer sistemlerinin, çok zayıf sinyalleri anlaşılır veriye
          dönüştürmesini sağlar.
        </h3>
      </div>

      <div
        className="container amac"
        id="amac"
        style={{
          height: "815px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "-5%",
        }}
      >
        <h1>Amaç</h1>
      </div>

      <div
        className="container "
        id="giris"
        style={{

          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h3
          style={{
            width: "80%",
            textAlign: "center",
          }}
        >
          MiniBit olarak amacımız da diğer algoritmaların eksik yönlerini
          kapatıp güçlü yönlerini daha da geliştirdiğimiz bu yeni algoritma
          sayesinde belgeler, görseller ve metinleri sıkıştırma sırasında
          yaşanan kayıpları ve uzay iletişimin en büyük problemlerinden biri
          olan gecikme süresini en aza indirerek uzay iletişimini en hızlı, en
          verimli ve en etkili hale getirmek. Bu sayede kayıpsız, hızlı ve
          verimli bir iletişim sağlamayı hedefliyoruz
        </h3>
      </div>
      <div
        className="container algoritmalar"
        id="algoritmalar"
        style={{
          height: "815px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "-5%",
          textAlign:"center",
          
        }}
      >
        <h1 style={{fontSize:"10rem"}}>Kullanılan Algoritmalar</h1>
      </div>

      <div
        className="container algoritmalar"
        id="algoritmalar"
        style={{

          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h3
          style={{
            width: "80%",
            textAlign: "center",
          }}
        >🔹 Run-Length Encoding
        </h3>
        <h4
          style={{
            width: "80%",
            textAlign: "center",
          }}
        >RLE (Run-Length Encoding), art arda gelen aynı verileri tek tek yazmak yerine, kaç kez tekrarlandığını belirterek veriyi sıkıştıran basit bir yöntemdir. Özellikle tekrar eden verilerde oldukça etkilidir ve veri boyutunu önemli ölçüde azaltabilir. Ancak tekrarın az olduğu durumlarda sıkıştırma verimsiz olur ve veri boyutu artabilir. Bu yüzden genellikle belirli veri türlerinde tercih edilir.
        </h4>
          <img src="https://api.zenofy.tr/other/rle.png" alt="rle" style={{
            width: "40%",
            marginBottom: "5%",marginTop:"1rem"}} />
        
        <h3
          style={{
            width: "80%",
            textAlign: "center",
          }}
        >🔹 FFMPEG
        </h3>
        <h4
          style={{
            width: "80%",
            textAlign: "center",
          }}
        >FFmpeg, ses ve video dosyalarını farklı codec'ler aracılığıyla sıkıştırabilen güçlü bir araçtır. H.264, H.265 (HEVC) veya AV1 gibi modern codec'ler kullanarak bir video dosyasının boyutunu kaliteden fazla ödün vermeden önemli ölçüde küçültebilir. Sıkıştırma seviyesi, kalite ve dosya boyutu arasındaki denge kullanıcı tarafından ayarlanabilir; bu da onu hem depolama hem de yayın senaryoları için oldukça esnek kılar. Ancak yüksek sıkıştırma oranları görsel kaliteyi düşürebilir ve yeniden kodlama işlemi özellikle yüksek çözünürlüklü içeriklerde ciddi işlem gücü gerektirir.


        </h4>
        <img src="https://api.zenofy.tr/other/ffmpeg.png" alt="ffmpeg" style={{
          width: "40%",
          marginBottom: "5%",marginTop:"1rem"}} />
        <h3
          style={{
            width: "80%",
            textAlign: "center",
          }}
        >🔹 Probable Combinations Encoding
        </h3>
        <h4
          style={{
            width: "80%",
            textAlign: "center",
          }}
        >“PCE (Probable Combinations Encoding) tarafımızca tasarlanmış olup, bir dosya içinde art arda tekrar eden bayt kombinasyonlarının kaç kez tekrarlandığını, tekrar eden baytlar yerine yazarak dosyayı sıkıştırır. Bu sayede karmaşık ve diğer sıkıştırma algoritmalarının işe yaramadığı dosyalar da sıkıştırılarak dosya boyutu önemli ölçüde küçültülebilir.”
        </h4>
      </div>

      <div
        className="container MiniBitt"
        id="MiniBit"
        style={{
          height: "815px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "-10%",
        }}
      >
        <h1 style={{
    backgroundImage: "linear-gradient(to right,rgba(0, 0, 255, 0.75) 1%, rgba(173, 216, 230, 0.75) 50%)",
    color: "transparent",
    textAlign:"center",
    padding:"2rem",
    backgroundClip: "text"}} >MiniBit</h1>
      </div>
    </div>
  );
}

export default App;
